import { EventListPageType } from '~/composables/types/strapiEventListPage'
import { GtmItemListId } from '~/composables/useKftGtm/types'

// Coarse page-type attribution for the main listing grid: we only care which
// kind of page the click came from, not which city/category it was
export const getListingGtmItemListId = (
  pageType: EventListPageType
): GtmItemListId | null => {
  switch (pageType) {
    case EventListPageType.SEARCH:
      return GtmItemListId.SearchPage
    case EventListPageType.CITY:
      return GtmItemListId.CityPage
    case EventListPageType.CATEGORY:
      return GtmItemListId.CategoryPage
    case EventListPageType.CITY_CATEGORY:
      return GtmItemListId.CityCategoryPage
    case EventListPageType.TEAMEVENT:
      return GtmItemListId.TeameventPage
    case EventListPageType.GENERAL:
      return GtmItemListId.TagPage
    default:
      return null
  }
}
